import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';
import { Colors } from '../../../themes/colors';

export const YoutubeIcon: React.FC<IconProps> = ({
  size = 24,
  color = Colors.role.textStrong,
  style,
  ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    overflow="visible"
    {...props}
    style={[{ overflow: 'visible' } as const, style] as unknown}
  >
    <Path fillRule="evenodd" clipRule="evenodd" d="M21.3 4C22.4 4.3 23.1 5 23.4 6.1C24 8.1 24 12 24 12C24 12 24 15.9 23.6 17.9C23.3 19 22.5 19.7 21.5 20C19.5 20.5 12 20.5 12 20.5C12 20.5 4.4 20.5 2.6 20C1.5 19.7 0.8 19 0.5 17.9C0 15.9 0 12 0 12C0 12 0 8.1 0.3 6.1C0.6 5 1.4 4.3 2.4 4C4.4 3.5 11.9 3.5 11.9 3.5C11.9 3.5 19.5 3.5 21.3 4ZM15.9 12L9.6 15.6V8.4L15.9 12Z" fill={color} />
  </Svg>
);

YoutubeIcon.displayName = 'YoutubeIcon';
